const mapping = {
    coverage: 'Coverage',
    facilityType: 'Facility',
    wholesaler: 'Wholesaler',
    carrier: 'Company',
    states: 'States',
    search: 'Search',
    order: 'Order',
    contacts: 'Contact'
}

export {mapping};